import React from 'react'
import { WidgetGuard } from 'features/types'
import DemographicTopicInaccessibleGuard from './DemographicTopicInaccessibleGuard'

const PreSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <DemographicTopicInaccessibleGuard widgetId={widgetId}>
    {children}
  </DemographicTopicInaccessibleGuard>
)

export default PreSearchDataGuards
